interface CountryInfo {
  name: string | Array<string>;
  code: string;
  children?: Array<string>
}

interface CountryCodeType {
  countryMap: Map<string, CountryInfo>;
  formatInternationalPhone: (input: any) => string;
}
const countryCode: CountryCodeType = {
  countryMap: new Map([
    ['1', { name: ['美国','加拿大'], code: '+1',
      children:['205, 251, 256, 334, 938,907,480, 520, 602, 623, 928, 479, 501, 870, 209, 213, 279, 310, 323, 408, 415,'
      + '424, 442, 510, 530, 559, 562, 619, 626, 628, 650, 657, 661, 669, 707, 714, 747, 760, 805, 818, 820, 831, 858,'
      + '909, 916, 925, 949, 951, 303, 719, 720, 970, 203, 475, 860, 959, 302, 239, 305, 321, 352, 386, 407, 561, 727,'
      + '754, 772, 786, 813, 850, 863, 904, 941, 954, 229, 404, 470, 478, 678, 706, 762, 770, 912, 808, 208, 986, 217,'
      + '224, 309, 312, 331, 618, 630, 708, 773, 779, 815, 847, 872, 219, 260, 317, 463, 574, 765, 812, 930, 319, 515,'
      + '563, 641, 712, 316, 620, 785, 913, 270, 364, 502, 606, 859, 225, 318, 337, 504, 985, 207, 240, 301, 410, 443,'
      + '667, 339, 351, 413, 508, 617, 774, 781, 857, 978, 231, 248, 269, 313, 517, 586, 616, 734, 810, 906, 947, 989,'
      + '218, 320, 507, 612, 651, 763, 952, 228, 601, 662, 769, 314, 417, 573, 636, 660, 816, 406, 308, 402, 531, 702,'
      + '725, 775, 603, 201, 551, 609, 640, 732, 848, 856, 862, 908, 973, 505, 575, 212, 315, 332, 347, 516, 518, 585,'
      + '607, 631, 646, 680, 716, 718, 838, 845, 914, 917, 929, 934, 252, 336, 704, 743, 828, 910, 919, 980, 984, 701,'
      + '216, 220, 234, 330, 380, 419, 440, 513, 567, 614, 740, 937, 405, 539, 580, 918, 458, 503, 541, 971, 215, 223,'
      + '267, 272, 412, 445, 484, 570, 610, 717, 724, 814, 878, 401, 803, 843, 854, 864 ,605, 423, 615, 629, 731, 865,'
      + '901, 931, 210, 214, 254, 281, 325, 346, 361, 409, 430, 432, 469, 512, 682, 713, 726, 737, 806, 817, 830, 832,'
      + '903, 915, 936, 940, 956, 972, 979, 385, 435, 801 ,802, 276, 434, 540, 571, 703, 757, 804, 206, 253, 360, 425,'
      + '509, 564, 202, 304, 681, 262, 414, 534, 608, 715, 920, 307','']}],
    ['7', { name: '俄罗斯/哈萨克斯坦', code: '+7' }],
    ['20', { name: '埃及', code: '+20' }],
    ['27', { name: '南非', code: '+27' }],
    ['30', { name: '希腊', code: '+30' }],
    ['31', { name: '荷兰', code: '+31' }],
    ['32', { name: '比利时', code: '+32' }],
    ['33', { name: '法国', code: '+33' }],
    ['34', { name: '西班牙', code: '+34' }],
    ['36', { name: '匈牙利', code: '+36' }],
    ['39', { name: '意大利/梵蒂冈', code: '+39' }],
    ['40', { name: '罗马尼亚', code: '+40' }],
    ['41', { name: '瑞士', code: '+41' }],
    ['43', { name: '奥地利', code: '+43' }],
    ['44', { name: '英国', code: '+44' }],
    ['45', { name: '丹麦', code: '+45' }],
    ['46', { name: '瑞典', code: '+46' }],
    ['47', { name: '挪威', code: '+47' }],
    ['48', { name: '波兰', code: '+48' }],
    ['49', { name: '德国', code: '+49' }],
    ['51', { name: '秘鲁', code: '+51' }],
    ['52', { name: '墨西哥', code: '+52' }],
    ['53', { name: '古巴', code: '+53' }],
    ['54', { name: '阿根廷', code: '+54' }],
    ['55', { name: '巴西', code: '+55' }],
    ['56', { name: '智利', code: '+56' }],
    ['57', { name: '哥伦比亚', code: '+57' }],
    ['58', { name: '委内瑞拉', code: '+58' }],
    ['60', { name: '马来西亚', code: '+60' }],
    ['61', { name: '澳大利亚', code: '+61' }],
    ['62', { name: '印度尼西亚', code: '+62' }],
    ['63', { name: '菲律宾', code: '+63' }],
    ['64', { name: '新西兰', code: '+64' }],
    ['65', { name: '新加坡', code: '+65' }],
    ['66', { name: '泰国', code: '+66' }],
    ['81', { name: '日本', code: '+81' }],
    ['82', { name: '韩国', code: '+82' }],
    ['84', { name: '越南', code: '+84' }],
    ['86', { name: '中国', code: '+86' }],
    ['90', { name: '土耳其', code: '+90' }],
    ['91', { name: '印度', code: '+91' }],
    ['92', { name: '巴基斯坦', code: '+92' }],
    ['93', { name: '阿富汗', code: '+93' }],
    ['94', { name: '斯里兰卡', code: '+94' }],
    ['95', { name: '缅甸', code: '+95' }],
    ['98', { name: '伊朗', code: '+98' }],
    ['211', { name: '南苏丹', code: '+211' }],
    ['212', { name: '摩洛哥', code: '+212' }],
    ['213', { name: '阿尔及利亚', code: '+213' }],
    ['216', { name: '突尼斯', code: '+216' }],
    ['218', { name: '利比亚', code: '+218' }],
    ['220', { name: '冈比亚', code: '+220' }],
    ['221', { name: '塞内加尔', code: '+221' }],
    ['222', { name: '毛里塔尼亚', code: '+222' }],
    ['223', { name: '马里', code: '+223' }],
    ['224', { name: '几内亚', code: '+224' }],
    ['225', { name: '科特迪瓦', code: '+225' }],
    ['226', { name: '布基纳法索', code: '+226' }],
    ['227', { name: '尼日尔', code: '+227' }],
    ['228', { name: '多哥', code: '+228' }],
    ['229', { name: '贝宁', code: '+229' }],
    ['230', { name: '毛里求斯', code: '+230' }],
    ['231', { name: '利比里亚', code: '+231' }],
    ['232', { name: '塞拉利昂', code: '+232' }],
    ['233', { name: '加纳', code: '+233' }],
    ['234', { name: '尼日利亚', code: '+234' }],
    ['235', { name: '乍得', code: '+235' }],
    ['236', { name: '中非共和国', code: '+236' }],
    ['237', { name: '喀麦隆', code: '+237' }],
    ['238', { name: '佛得角', code: '+238' }],
    ['239', { name: '圣多美和普林西比', code: '+239' }],
    ['240', { name: '赤道几内亚', code: '+240' }],
    ['241', { name: '加蓬', code: '+241' }],
    ['242', { name: '刚果（布）', code: '+242' }],
    ['243', { name: '刚果（金）', code: '+243' }],
    ['244', { name: '安哥拉', code: '+244' }],
    ['245', { name: '几内亚比绍', code: '+245' }],
    ['246', { name: '英属印度洋领地', code: '+246' }],
    ['247', { name: '阿森松岛', code: '+247' }],
    ['248', { name: '塞舌尔', code: '+248' }],
    ['249', { name: '苏丹', code: '+249' }],
    ['250', { name: '卢旺达', code: '+250' }],
    ['251', { name: '埃塞俄比亚', code: '+251' }],
    ['252', { name: '索马里', code: '+252' }],
    ['253', { name: '吉布提', code: '+253' }],
    ['254', { name: '肯尼亚', code: '+254' }],
    ['255', { name: '坦桑尼亚', code: '+255' }],
    ['256', { name: '乌干达', code: '+256' }],
    ['257', { name: '布隆迪', code: '+257' }],
    ['258', { name: '莫桑比克', code: '+258' }],
    ['260', { name: '赞比亚', code: '+260' }],
    ['261', { name: '马达加斯加', code: '+261' }],
    ['262', { name: '留尼汪/马约特', code: '+262' }],
    ['263', { name: '津巴布韦', code: '+263' }],
    ['264', { name: '纳米比亚', code: '+264' }],
    ['265', { name: '马拉维', code: '+265' }],
    ['266', { name: '莱索托', code: '+266' }],
    ['267', { name: '博茨瓦纳', code: '+267' }],
    ['268', { name: '斯威士兰', code: '+268' }],
    ['269', { name: '科摩罗', code: '+269' }],
    ['290', { name: '圣赫勒拿/特里斯坦-达库尼亚群岛', code: '+290' }],
    ['291', { name: '厄立特里亚', code: '+291' }],
    ['297', { name: '阿鲁巴', code: '+297' }],
    ['298', { name: '法罗群岛', code: '+298' }],
    ['299', { name: '格陵兰', code: '+299' }],
    ['350', { name: '直布罗陀', code: '+350' }],
    ['351', { name: '葡萄牙', code: '+351' }],
    ['352', { name: '卢森堡', code: '+352' }],
    ['353', { name: '爱尔兰', code: '+353' }],
    ['354', { name: '冰岛', code: '+354' }],
    ['355', { name: '阿尔巴尼亚', code: '+355' }],
    ['356', { name: '马耳他', code: '+356' }],
    ['357', { name: '塞浦路斯', code: '+357' }],
    ['358', { name: '芬兰', code: '+358' }],
    ['359', { name: '保加利亚', code: '+359' }],
    ['370', { name: '立陶宛', code: '+370' }],
    ['371', { name: '拉脱维亚', code: '+371' }],
    ['372', { name: '爱沙尼亚', code: '+372' }],
    ['373', { name: '摩尔多瓦', code: '+373' }],
    ['374', { name: '亚美尼亚', code: '+374' }],
    ['375', { name: '白俄罗斯', code: '+375' }],
    ['376', { name: '安道尔', code: '+376' }],
    ['377', { name: '摩纳哥', code: '+377' }],
    ['378', { name: '圣马力诺', code: '+378' }],
    ['380', { name: '乌克兰', code: '+380' }],
    ['381', { name: '塞尔维亚', code: '+381' }],
    ['382', { name: '黑山', code: '+382' }],
    ['383', { name: '科索沃', code: '+383' }],
    ['385', { name: '克罗地亚', code: '+385' }],
    ['386', { name: '斯洛文尼亚', code: '+386' }],
    ['387', { name: '波斯尼亚和黑塞哥维那', code: '+387' }],
    ['389', { name: '北马其顿', code: '+389' }],
    ['420', { name: '捷克', code: '+420' }],
    ['421', { name: '斯洛伐克', code: '+421' }],
    ['423', { name: '列支敦士登', code: '+423' }],
    ['500', { name: '福克兰群岛（马尔维纳斯群岛）', code: '+500' }],
    ['501', { name: '伯利兹', code: '+501' }],
    ['502', { name: '危地马拉', code: '+502' }],
    ['503', { name: '萨尔瓦多', code: '+503' }],
    ['504', { name: '洪都拉斯', code: '+504' }],
    ['505', { name: '尼加拉瓜', code: '+505' }],
    ['506', { name: '哥斯达黎加', code: '+506' }],
    ['507', { name: '巴拿马', code: '+507' }],
    ['508', { name: '圣皮埃尔和密克隆群岛', code: '+508' }],
    ['509', { name: '海地', code: '+509' }],
    ['590', { name: '圣巴泰勒米/法属圣马丁/瓜德罗普', code: '+590' }],
    ['591', { name: '玻利维亚', code: '+591' }],
    ['592', { name: '圭亚那', code: '+592' }],
    ['593', { name: '厄瓜多尔', code: '+593' }],
    ['594', { name: '法属圭亚那', code: '+594' }],
    ['595', { name: '巴拉圭', code: '+595' }],
    ['596', { name: '马提尼克', code: '+596' }],
    ['597', { name: '苏里南', code: '+597' }],
    ['598', { name: '乌拉圭', code: '+598' }],
    ['599', { name: '库拉索/荷属加勒比区', code: '+599' }],
    ['670', { name: '东帝汶', code: '+670' }],
    ['672', { name: '诺福克岛', code: '+672' }],
    ['673', { name: '文莱', code: '+673' }],
    ['674', { name: '瑙鲁', code: '+674' }],
    ['675', { name: '巴布亚新几内亚', code: '+675' }],
    ['676', { name: '汤加', code: '+676' }],
    ['677', { name: '所罗门群岛', code: '+677' }],
    ['678', { name: '瓦努阿图', code: '+678' }],
    ['679', { name: '斐济', code: '+679' }],
    ['680', { name: '帕劳', code: '+680' }],
    ['681', { name: '瓦利斯和富图纳', code: '+681' }],
    ['682', { name: '库克群岛', code: '+682' }],
    ['683', { name: '纽埃', code: '+683' }],
    ['685', { name: '萨摩亚', code: '+685' }],
    ['686', { name: '基里巴斯', code: '+686' }],
    ['687', { name: '新喀里多尼亚', code: '+687' }],
    ['688', { name: '图瓦卢', code: '+688' }],
    ['689', { name: '法属波利尼西亚', code: '+689' }],
    ['690', { name: '托克劳', code: '+690' }],
    ['691', { name: '密克罗尼西亚', code: '+691' }],
    ['692', { name: '马绍尔群岛', code: '+692' }],
    ['850', { name: '朝鲜', code: '+850' }],
    ['852', { name: '香港', code: '+852' }],
    ['853', { name: '澳门', code: '+853' }],
    ['855', { name: '柬埔寨', code: '+855' }],
    ['856', { name: '老挝', code: '+856' }],
    ['880', { name: '孟加拉国', code: '+880' }],
    ['886', { name: '台湾', code: '+886' }],
    ['960', { name: '马尔代夫', code: '+960' }],
    ['961', { name: '黎巴嫩', code: '+961' }],
    ['962', { name: '约旦', code: '+962' }],
    ['963', { name: '叙利亚', code: '+963' }],
    ['964', { name: '伊拉克', code: '+964' }],
    ['965', { name: '科威特', code: '+965' }],
    ['966', { name: '阿联酋', code: '+966' }],
    ['967', { name: '也门', code: '+967' }],
    ['968', { name: '阿曼', code: '+968' }],
    ['970', { name: '巴勒斯坦', code: '+970' }],
    ['971', { name: '阿拉伯联合酋长国', code: '+971' }],
    ['972', { name: '以色列', code: '+972' }],
    ['973', { name: '巴林', code: '+973' }],
    ['974', { name: '卡塔尔', code: '+974' }],
    ['975', { name: '不丹', code: '+975' }],
    ['976', { name: '蒙古', code: '+976' }],
    ['977', { name: '尼泊尔', code: '+977' }],
    ['992', { name: '塔吉克斯坦', code: '+992' }],
    ['993', { name: '土库曼斯坦', code: '+993' }],
    ['994', { name: '阿塞拜疆', code: '+994' }],
    ['995', { name: '格鲁吉亚', code: '+995' }],
    ['996', { name: '吉尔吉斯斯坦', code: '+996' }],
    ['998', { name: '乌兹别克斯坦', code: '+998' }]
  ]),
  formatInternationalPhone: (input: any) => {
    // 统一输入为字符串并移除非数字字符
    const numStr = String(input).replace(/\D/g, '');
    if (numStr.length <= 5) {
      return '';
    }
    const sortedCodes = Array.from(countryCode.countryMap.keys()).sort(
      (a, b) => b.length - a.length
    );
    for (const code of sortedCodes) {
      if (numStr.startsWith(code)) {
        const local = numStr.slice(code.length);
        const countryInfo = countryCode.countryMap.get(code);
        if (countryInfo) {
          if (code === '1' && countryInfo.children) {
            const children = numStr.substring(1, 4);
            let index = -1;
            index = countryInfo.children.findIndex((c) => {
              return c.indexOf(children) > -1
            });
            return `${countryInfo.name[index > -1 ? index : 1]} (${countryInfo.code}) ${local}`;
          } else {
            return `${countryInfo.name} (${countryInfo.code}) ${local}`;
          }

        }
      }
    }
    return `未知国家 (+${numStr})`;
  }
};
export default countryCode;
